import actions from './actions';

import { DataService } from '../../config/data/dataService';
const {  
    storeDashboardDataBegin, storeDashboardDataSuccess, storeDashboardDataErr, 
    splProductTargetBegin, splProductTargetSuccess, splProductTargetErr,
    getProductDiscoveryTokenBegin, getProductDiscoveryTokenSuccess, getProductDiscoveryTokenErr,
    storeContentVideoDetailsBegin, storeContentVideoDetailsSuccess, storeContentVideoDetailsErr,
    storeContentVideoDownloadBegin, storeContentVideoDownloadSuccess, storeContentVideoDownloadErr,
} = actions;

// Store Dashboard Data
export const getStoreDashboardData = () => {
    return async (dispatch) => {
        try {
            dispatch(storeDashboardDataBegin());
            const response = await DataService.get('/getStoreDashboardData');
            if (response.status === 200 && response.data.status === true) {
                dispatch(storeDashboardDataSuccess(response.data.data));
            } else {
                dispatch(storeDashboardDataErr());
            }
        } catch (err) {
            dispatch(storeDashboardDataErr(err));
        }
    };
}

export const getSplProductTarget = () => {
    return async (dispatch) => {
        try {
            dispatch(splProductTargetBegin());
            const response = await DataService.get('/getSplProductTarget');
            if (response.status === 200 && response.data.status === true) {
                dispatch(splProductTargetSuccess(response.data.data));
            } else {
                dispatch(splProductTargetErr(response.data.message));
            }
        } catch (err) {
            dispatch(splProductTargetErr(err));
        }
    };
}

// Get Product Discovery Token
export const getProductDiscoveryToken = () => {
    return async (dispatch) => {
        try {
            dispatch(getProductDiscoveryTokenBegin());
            const response = await DataService.get('/getProductDiscoveryToken');
            if (response.status === 200 && response.data.status === true) {
                dispatch(getProductDiscoveryTokenSuccess(response.data.data));
            } else {
                dispatch(getProductDiscoveryTokenErr());
            }
        } catch (err) {
            dispatch(getProductDiscoveryTokenErr(err));
        }
    };
}

export const getStoreContentVideoDetails = () => {
    return async (dispatch) => {
        try {
            dispatch(storeContentVideoDetailsBegin());
            const response = await DataService.get('/getStoreContentVideoDetails');
            if (response.status === 200 && response.data.status === true) {
                dispatch(storeContentVideoDetailsSuccess(response.data.data));
            } else {
                dispatch(storeContentVideoDetailsErr(response.data.message));
            }
        } catch (err) {
            dispatch(storeContentVideoDetailsErr(err));
        }
    };
}

export const storeContentVideoDownloadLog = (data) => {
    return async (dispatch) => {
        try {
            dispatch(storeContentVideoDownloadBegin());
            const response = await DataService.post('/storeContentVideoDownloadLog', data);
            if (response.status === 200 && response.data.status === true) {
                dispatch(storeContentVideoDownloadSuccess(response.data.data));
                return response.data;
            } else {
                dispatch(storeContentVideoDownloadErr(response.data.message));
                return response.data;
            }
        } catch (err) {
            dispatch(storeContentVideoDownloadErr(err));
            return null;
        }
    };
}
